import {
    IUnorderedHorizontalListItem,
    IUnorderedHorizontalListProperties,
    UnorderedHorizontalList,
} from '@vfde-brix/ws10/unordered-horizontal-list';
import { JarvisProduct } from '../../interface';
import { getPriceListLink } from '../cms';

const getItemWithUpdatedLink = (
    item: IUnorderedHorizontalListItem,
    link: string,
): IUnorderedHorizontalListItem => ({
    ...item,
    link: {
        ...item.link,
        stdLinkUrl: link,
    },
});

/**
 * Gets link list items
 *
 * @param list - The list component to be updated
 * @param tariff - The selected tariff
 */
export const getLinkListItems = (
    list: UnorderedHorizontalList | null,
    tariff?: JarvisProduct,
): Partial<IUnorderedHorizontalListProperties<IUnorderedHorizontalListItem>> => {
    const { items } = list?.getProperties() || {};

    if (!tariff || !items || items.length !== 2) {
        return { items };
    }

    return {
        items: [
            getItemWithUpdatedLink(items[0], getPriceListLink(tariff.isUnity)),
            getItemWithUpdatedLink(items[1], tariff.pdfLink),
        ],
    };
};
